import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { Box, Button, Divider } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';

interface ArticleGridToolbarProps {
  onRefreshClick: () => Promise<void>;
}

const ArticleGridToolbar = (props: ArticleGridToolbarProps) => {
  return (
    <>
      <Box display="flex" justifyContent="space-between" marginBottom=".5em">
        <GridToolbarContainer sx={{ paddingTop: '1em', paddingLeft: '1em' }}>
          <Button
            variant="contained"
            color="success"
            startIcon={<RefreshRoundedIcon />}
            onClick={props.onRefreshClick}
            size="small"
          >
            Refresh
          </Button>
          <GridToolbarColumnsButton variant="contained" />
          <GridToolbarDensitySelector variant="contained" />
          <GridToolbarExport variant="contained" />
        </GridToolbarContainer>
        <GridToolbarQuickFilter
          variant="outlined"
          size="small"
          sx={{ marginTop: '1em', marginRight: '1em' }}
        />
      </Box>
      <Divider />
    </>
  );
};

export default ArticleGridToolbar;
